export default {"src":"/_next/static/media/0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22.7a888b80.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};